import GardenAPI from '../../../../garden/gardenAPI.js';
import { ObjectEvent } from '../../../../helpers/coreEnums.js';
import { handleDeselected, handleSelected } from '../nodes/selectionHandlers.js';

/**
 * Register events to the canvas that are needed for the pipes
 * @param canvas
 */
export function registerPipeCanvasEvents(canvas) {
  GardenAPI.objects.getBySlug('pipe-node').forEach((nodeEl) => {
    nodeEl.on(ObjectEvent.selected, _handleNodeSelection);
  });
}

/**
 *
 * @param event
 * @private
 */
function _handleNodeSelection(event) {
  if (event.target.slug === 'pipe-node') {
    const nodeElement = event.target;
    handleSelected(event, nodeElement);
    nodeElement.once(ObjectEvent.deselected, function () {
      handleDeselected(event, nodeElement);
    });
  }
}
